export default __webpack_public_path__ + "static/media/feature-localization.390b00c6.webp";